import { CustomAxiosRequestConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../../models/api-resource.interface';
import { BulkImportUser, User } from './../../users/user.interface';
import { Batch } from '../../batches/batch.interface';

export class UserService {
   async getUsers(tenantId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<User>>>(`/tenants/${tenantId}/users`, { params: { ...query } });
      return response.data;
   }

   async getUser() {
      throw Error('Method not implemented');
   }

   async postUser(tenantId: number, user: User) {
      const response = await http.post<User>(`/tenants/${tenantId}/users`, user);
      return response.data;
   }

   async putUser() {
      throw Error('Method not implemented');
   }

   async deleteUser(tenantId: number, userId: number) {
      const response = await http.delete(`/tenants/${tenantId}/users/${userId}`);
      return response.data;
   }

   async userBatch(tenantId: number, users: Array<BulkImportUser>): Promise<Batch> {
      const response = await http.post<Batch>(`/tenants/${tenantId}/user-batch`, { users }, {
         showError: false,
      } as CustomAxiosRequestConfig);
      return response.data;
   }
}
